import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { MultiOrderNotice } from '@zero/trade/domain';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  selector: 'trade-multi-order-notice',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe, NgTemplateOutlet, RouterLink, ButtonComponent],
  templateUrl: './multi-order-notice.component.html',
})
export class MultiOrderNoticeComponent {
  @Input() public notice: MultiOrderNotice;

  @Output() public proceed = new EventEmitter<void>();

  public MultiOrderNotice = MultiOrderNotice;
  public commonRoutes = commonRoutes;
}
